import { TimelineNote } from '@/components/Timeline/types';
import dayjs from 'dayjs';

export function formatDate(date: dayjs.ConfigType, format: string = 'MMMM D, YYYY'): string {
  if (!date) {
    return '';
  }

  return dayjs(date).format(format);
}

export function formatTime(date: dayjs.ConfigType, format: string = 'h:mma'): string {
  const result = dayjs(date).format(format);

  return result.split(':')[1].startsWith('00') ? result.replace(':00', '') : result;
}

// TODO: refactor this function to use formatToAdobeSpectrumFormat function and update the usage in the project
export function formatDatetime(date: dayjs.ConfigType, format: string = 'MMMM D, YYYY h:mm A'): string {
  return dayjs(date).format(format);
}

export function formatToAdobeSpectrumFormat(
  date: dayjs.ConfigType,
  dateFormat: string = 'MMMM D, YYYY',
  timeFormat: string = 'h:mma'
): string {
  const dateString = formatDate(date, dateFormat);
  const timeString = formatTime(date, timeFormat);
  return `${dateString} ${timeString}`;
}

export function convertToISOString(date: Date | string) {
  return date instanceof Date ? date.toISOString() : dayjs(date).toISOString();
}

export function getTimestamp(note: TimelineNote) {
  if (!note.timestamp) {
    return '';
  }
  return dayjs(note.timestamp).format('MM/DD/YY [at] h:mma');
}

/**
 * Checks if a date falls within a date range (inclusive).
 * @param itemDate - The date to check
 * @param startDate - The start of the range (inclusive, at 00:00:00)
 * @param endDate - The end of the range (inclusive, at 23:59:59.999)
 * @returns true if the date is within the range, false otherwise
 */
export function isDateInRange(itemDate: Date, startDate: Date | null, endDate: Date | null): boolean {
  if (startDate) {
    const startOfStartDate = new Date(startDate);
    startOfStartDate.setHours(0, 0, 0, 0);
    if (itemDate < startOfStartDate) return false;
  }

  if (endDate) {
    const endOfEndDate = new Date(endDate);
    endOfEndDate.setHours(23, 59, 59, 999);
    if (itemDate > endOfEndDate) return false;
  }

  return true;
}
